import styled, { css } from 'styled-components';

export const Container = styled.main`
  ${({ theme }) => css`
    width: 100%;

    background: ${theme.palette.neutral[50]};
    padding: ${theme.layout.spacing(4)};

    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${theme.layout.spacing(2)};
    gap: ${theme.layout.spacing(2)};

    text-align: center;
  `}
`;
